import { useState } from 'react'

const useAppState = () => {
  const [language, setLanguage] = useState('en')
  const initialStateInsured = {
    name: '',
    nricPassport: '',
    bizRegNo: '',
    newSSMId: '',
    dateOfBirth: '',
    gender: '',
    email: '',
    confirmEmail: '',
    mobile: '',
    marital: '',
    address1: '',
    address2: '',
    address3: '',
    postcode: '',
    city: '',
    addState: '',
    type: 'P',
    occpCode: '',
    typeOfBusiness: '',
    nationality: '',
    isNric: false,
  }
  const [insured, setInsured] = useState(initialStateInsured)
  const reduceInsured = (state) => {
    const { nricPassport } = state
    let dateOfBirth = state.dateOfBirth || insured.dateOfBirth
    let gender = state.gender || insured.gender
    let isNric = insured.isNric
    let nationality = state.nationality || insured.nationality
    if (nricPassport) {
      const strippedNric = nricPassport.replace(/-/g, '')
      if (strippedNric.length === 12 && /^\d+$/.test(strippedNric)) {
        isNric = true
        const baseYear = 1900
        const currentYear = new Date().getFullYear()
        const maxAge = 90
        let year = baseYear + parseInt(nricPassport.substr(0, 2))
        if (currentYear - year >= maxAge) year += 100
        const month = parseInt(nricPassport.substr(2, 2))
        const day = parseInt(nricPassport.substr(4, 2))
        dateOfBirth = new Date(year, month - 1, day)
        if (!state.gender) {
          const lastDigitNric = parseInt(nricPassport.substr(-1))
          gender = lastDigitNric % 2 === 0 ? 'F' : 'M'
        }
        nationality = 'MYS'
      }
    }

    setInsured({
      ...insured,
      ...state,
      dateOfBirth,
      gender,
      nationality,
      isNric,
    })
  }
  const initialStateVehicle = {
    vehicleNumber: '',
    year: '',
    make: '',
    model: '',
    makeModel: '',
    variants: [],
    seat: 0,
    // variant: {},
    nvic: '',
    engineNo: '',
    chassisNo: '',
    cc: '',
    region: '',
    useOfVehicle: '',
    sumInsured: 0,
    sumInsuredOptions: [],
    financing: '4', // N/A default value
    loanCompany: '516', // Loan Company Default Value
    claimsAtFault: 0,
    windscreenClaims: 0,
    allowWindscreen: 'Y',
    odometer: 0,
    availableNvics: [],
  }
  const [vehicle, setVehicle] = useState(initialStateVehicle)

  // To improve the handling for checking url path
  const initialProduct = (() => {
    if (typeof window !== 'undefined') {
      const path = window.location.pathname
      if (path.includes('/MotorSafe')) {
        return {
          value: 'ms',
          label: 'Motor Safe',
        }
      }
      return {
        value: 'sm',
        label: 'SOMPO Motor',
      }
    }

    return undefined // Return as undefined during Server Side Rendering
  })()

  const [product, setProduct] = useState('sm')

  const initialStateQuote = {
    product: initialProduct,
    coverageType: 'sm',
    basicPremium: 0,
    ncdPercent: 0,
    ncdAmount: 0,
    totalBasePremium: 0,
    grossPremium: 0,
    rebatePercent: 10,
    rebateAmount: 0,
    sstPercent: 0,
    sstAmount: 0,
    stampDuty: 0,
    totalPremium: 0,
    inceptionDate: '',
    expiryDate: '',
    extraCoverageAmount: 0,
    selectedCoverageAmount: 0,
    covernoteNo: '',
    partner: '',
    transactionReferenceNumber: '',
    renewalNo: '',
    prevMsafe: ''
  }
  const [quotation, setQuotation] = useState(initialStateQuote)

  const [normalTotalPremium, setNormalTotalPremium] = useState(0)
  const [excessTotalPremium, setExcessTotalPremium] = useState(0)
  const [tpftTotalPremium, setTpftTotalPremium] = useState(0)
  const [msafeTotalPremium, setMsafeTotalPremium] = useState(0)

  // msafe plans:
  // PL01
  // PL02
  // PL03
  const [msafePlan, setMsafePlan] = useState('PL01')
  const [msafePicLink, setMsafePicLink] = useState('')
  const [msafePicName, setMsafePicName] = useState('')
  const [msafeFile, setMsafeFile] = useState('')
  const [msafeFileUrl, setMsafeFileUrl] = useState('')
  const [odoPhotoUrl, setOdoPhotoUrl] = useState('')
  const [msafeQuotation, setMsafeQuotation] = useState({
    sumInsured: 0,
    isAgreedValue: false,
  })

  const [motorNowSumInsured, setMotorNowSumInsured] = useState(0)

  const [isQuotationRefreshed, setIsQuotationRefreshed] = useState(true)

  const [sumInsureds, setSumInsureds] = useState([])
  const [sumInsuredsMsafe, setSumInsuredsMsafe] = useState([])
  const [addons, setAddons] = useState([
    {
      CODE: '89A',
      SUM_INSURED: 1000,
      PREMIUM: '50',
    },
    {
      CODE: '57',
      PREMIUM: '50',
    },
    {
      CODE: '112',
      PREMIUM: '50',
      CART_DAYS: 7,
      CART_AMOUNT: 50,
    },
    {
      CODE: 'PLC',
      PREMIUM: '50',
    },
    {
      CODE: '72',
      PREMIUM: '50',
    },
    {
      CODE: 'EHRP',
      PREMIUM: '50',
    },
    {
      CODE: '111',
      PREMIUM: '50',
    },
    {
      CODE: 'BTWP',
      PREMIUM: '50',
    },
    {
      CODE: '97',
      SUM_INSURED: 1000,
      PREMIUM: '50',
    },
    {
      CODE: '25',
      PREMIUM: '50',
    },
  ])
  const [cart, setCart] = useState('750')
  const [paPlan, setPAPlan] = useState('PA2P')

  const [isCurrentTpft, setisCurrentTpft] = useState(false)
  // isMSafeAvail - To Control Multiple Plan Display
  const [isMSafeAvail, setIsMSafeAvail] = useState(false)
  const [selectedAddons, setSelectedAddons] = useState([])
  const [isPaSelected, setIsPaSelected] = useState(false)
  const [upSellPrompted, setUpSellPrompted] = useState(false)
  const [detailPolicyData, setDetailPolicyData] = useState(null)
  const [isAddonsLoad, setIsAddonsLoad] = useState(false)
  const [isTpftLoading, setisTpftLoading] = useState(false)
  const [isMSafeLoad, setIsMSafeLoad] = useState(false)
  const [isSMLoad, setIsSMLoad] = useState(false)
  const [showResults, setShowResults] = useState(false)
  const [corAddress, setCorAddress] = useState(false)
  const [contactNo, setContactNo] = useState(false)
  const [occp, setOccp] = useState(false)
  const [promoCode, setPromoCode] = useState('')
  const [paymentId, setPaymentId] = useState(0)

  // For Plan Header Navigation Purpose
  const [coveragePageActive, setCoveragePageActive] = useState(false)
  const [planPageActive, setPlanPageActive] = useState(false)
  const [detailPageActive, setDetailPageActive] = useState(false)
  const [quotationPayload, setQuotationPayload] = useState(null)
  const handleVehicle = ({ make, model }) => {
    let state = {}
    if (make !== vehicle.make) {
      state.make = make
      state.model = ''
    }

    setVehicle({
      ...vehicle,
      ...state,
    })
  }

  const reduceVehicle = (state) => {
    // if (state.sumInsured) {
    //   setSumInsureds([
    //     state.sumInsured * 0.9,
    //     state.sumInsured * 0.95,
    //     state.sumInsured
    //   ])
    // }

    setVehicle((prevState) => ({
      ...prevState,
      ...state,
    }))
  }

  const reduceQuotation = (state) => {
    setQuotation({
      ...quotation,
      ...state,
    })
  }

  const [getRenewal, setGetRenewal] = useState(false)
  const [isRenewal, setIsRenewal] = useState(false)
  const [otpEmail, setOtpEmail] = useState('')

  // 17/01/2024 Lucas
  // Added states for bundle code
  const [bundleCode, setBundleCode] = useState('')
  const [bundlePremium, setBundlePremium] = useState(0)
  const [smSumInsured, setSmSumInsured] = useState('100')
  const [showSISlider, setShowSIslider] = useState(true)
  return {
    product,
    setProduct,
    insured,
    setInsured: reduceInsured,
    vehicle,
    setVehicle: reduceVehicle,
    handleVehicle,
    quotation,
    setQuotation: reduceQuotation,
    normalTotalPremium,
    setNormalTotalPremium,
    excessTotalPremium,
    setExcessTotalPremium,
    tpftTotalPremium,
    setTpftTotalPremium,
    isQuotationRefreshed,
    setIsQuotationRefreshed,
    sumInsureds,
    setSumInsureds,
    sumInsuredsMsafe,
    setSumInsuredsMsafe,
    addons,
    setAddons: setAddons,
    selectedAddons,
    setSelectedAddons,
    cart,
    setCart,
    isCurrentTpft,
    setisCurrentTpft,
    isAddonsLoad,
    setIsAddonsLoad,
    isTpftLoading,
    setisTpftLoading,
    showResults,
    setShowResults,
    corAddress,
    setCorAddress,
    contactNo,
    setContactNo,
    occp,
    setOccp,
    promoCode,
    setPromoCode,
    paPlan,
    setPAPlan,
    paymentId,
    setPaymentId,
    getRenewal,
    setGetRenewal,
    isRenewal,
    setIsRenewal,
    isMSafeLoad,
    setIsMSafeLoad,
    msafeTotalPremium,
    setMsafeTotalPremium,
    msafePlan,
    setMsafePlan,
    msafePicLink,
    setMsafePicLink,
    msafePicName,
    setMsafePicName,
    msafeFile,
    setMsafeFile,
    odoPhotoUrl,
    setOdoPhotoUrl,
    msafeQuotation,
    setMsafeQuotation,
    motorNowSumInsured,
    setMotorNowSumInsured,
    language,
    setLanguage,
    isMSafeAvail,
    setIsMSafeAvail,
    initialStateInsured,
    initialStateQuote,
    initialStateVehicle,
    coveragePageActive,
    setCoveragePageActive,
    msafeFileUrl,
    setMsafeFileUrl,
    planPageActive,
    setPlanPageActive,
    detailPageActive,
    setDetailPageActive,
    bundleCode,
    setBundleCode,
    bundlePremium,
    setBundlePremium,
    smSumInsured,
    setSmSumInsured,
    showSISlider,
    setShowSIslider,
    otpEmail,
    setOtpEmail,
    quotationPayload,
    setQuotationPayload,
    isSMLoad,
    setIsSMLoad,
    isPaSelected,
    setIsPaSelected,
    detailPolicyData,
    setDetailPolicyData,
    upSellPrompted,
    setUpSellPrompted,
  }
}

export default useAppState
